<template>
  <div class="modal fade py-1" id="mod-add" role="dialog">
    <div class="modal-dialog mx-auto">
      <div class="modal-content p-[24px] bg-[#f8f8f8]">
        <div class="modal-header flex items-start justify-between p-0 m-0">
          <h4
            class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
          >
            Add New Member
          </h4>
          <button
            class="text-2xl text-[#353535]"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="modal-body m-0 p-0">
          <div class="mb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Member Type</label
            >
            <div>
              <select
                class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                :class="[{ 'is-invalid': $v.newMember.type.$error }]"
                placeholder="Select an option"
                v-model.trim="$v.newMember.type.$model"
              >
                <option v-for="type in types" :key="type" :value="type">
                  {{ type }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="!$v.newMember.type.required">
                Field is required.
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Member Name</label
            >
            <div>
              <select
                :class="[{ 'is-invalid': $v.newMember.memberId.$error }]"
                placeholder="Select an option"
                v-model.trim="$v.newMember.memberId.$model"
                class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
              >
                <option v-if="isBusyModal" value="">Loading...</option>
                <option v-for="m in newMembers" :key="m.id" :value="m.id">
                  {{ m.text }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="!$v.newMember.memberId.required"
              >
                Field is required.
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-[8px] mt-[16px]">
          <button
            class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
            type="button"
            data-dismiss="modal"
            @click="reset"
          >
            Cancel
          </button>
          <button
            :disabled="isBusyModal"
            class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
            type="button"
            @click.prevent="add"
          >
            <span
              v-if="isMemberLoading || isAdding"
              class="spinner-border spinner-border-sm"
              role="status"
            >
              <i class="sr-only">Loading...</i>
            </span>
            <span v-else>Add member</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "AddNewMember",
  props: ["campaignId"],

  data() {
    return {
      isBusyModal: false,
      newMember: {
        type: "",
        memberId: "",
        campaignId: this.campaignId,
      },
      types: [],
      newMembers: [],
      isMemberLoading: false,
      isAdding: false,
    };
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },

  watch: {
    "newMember.type": function(newVal) {
      this.onTypeChange(newVal);
    },
  },

  validations: {
    newMember: {
      type: {
        required,
      },

      memberId: {
        required,
      },
    },
  },

  mounted() {
    this.getTypes();
  },

  methods: {
    getTypes() {
      this.types = ["Group", "Customer"];
    },

    async onTypeChange(type) {
      if (type) {
        switch (type) {
          case "Group":
            this.isBusyModal = true;
            this.isMemberLoading = true;
            try {
              const response = await this.$http.get(
                "/Groups/getItemList/" + this.user.parentId
              );

              if (response.ok) this.newMembers = response.body;
            } catch (error) {}
            this.isBusyModal = false;
            this.isMemberLoading = false;
            break;
          case "Merchant":
            this.isBusyModal = true;
            this.isMemberLoading = true;

            try {
              const response = await this.$http.get(
                "/Accounts/getItemList?parentId=" +
                  this.user.parentId +
                  "&accountType=" +
                  this.user.type
              );

              if (response.ok) this.newMembers = response.body;
            } catch (error) {}
            this.isBusyModal = false;
            this.isMemberLoading = false;
            break;
          case "Customer":
            this.isBusyModal = true;
            this.isMemberLoading = true;
            try {
              const response = await this.$http.get(
                "/Users/getItemListOfCustomers/" + this.user.parentId
              );
              if (response.ok)
                this.newMembers = response.body.filter(
                  (x) => x.text !== "In Store"
                );
            } catch (error) {}

            this.isBusyModal = false;
            this.isMemberLoading = false;
            break;
          default:
            break;
        }
      }
    },

    async add() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isBusyModal = true;
        this.isAdding = true;

        try {
          const response = await this.$http.post(
            "/Campaigns/addMember",
            this.newMember
          );
          if (response.ok) {
            this.isAdding = false;
            this.reset();
            this.$emit("onMemberAddComplete");
          }
        } catch (error) {}

        this.isBusyModal = false;
        this.isAdding = false;
      }
    },

    reset() {
      this.newMember = {
        type: "",
        memberId: "",
        campaignId: "",
      };

      setTimeout(() => {
        this.$v.$reset();
      }, 0);
    },
  },
};
</script>
